export default __webpack_public_path__ + "static/media/WB_logo_side_brown.aa03f562.png";